import React from 'react';
import PropTypes from 'prop-types';

import { TextField, TagAdd } from '../../index';

import { StyledLabel, StyledFormControl } from '../../Input/style';

const MedicalRecord = ({ data, onChange, onAddTag }) => {
    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        let newData = { ...data };
        newData[name] = value;
        onChange(newData);
    };

    return (
        <div>
            <TextField
                id="mse"
                name="mse"
                label="Mental State Examination (MSE)"
                placeholder="Mental State Examination (MSE)"
                value={data.mse}
                onChange={(e) => handleChange(e)}
                inputProps={{ maxLength: 2000 }}
            />
            <TextField
                id="diagnosis"
                name="diagnosis"
                label="Provisional diagnosis"
                placeholder="Provisional diagnosis"
                value={data.diagnosis}
                onChange={(e) => handleChange(e)}
                minRows={8}
                inputProps={{ maxLength: 2000 }}
            />
            <StyledFormControl>
                <StyledLabel>Client Tag</StyledLabel>
                <TagAdd data={data.tag} onAddTag={onAddTag} />
            </StyledFormControl>

            <TextField
                id="treatment"
                name="treatment"
                label="Treatment"
                placeholder="Treatment"
                value={data.treatment}
                onChange={(e) => handleChange(e)}
                inputProps={{ maxLength: 2000 }}
            />
            <TextField
                id="noteToPsychiatrist"
                name="noteToPsychiatrist"
                label="Note to Provider"
                placeholder="Note to Provider"
                value={data.noteToPsychiatrist}
                onChange={(e) => handleChange(e)}
                inputProps={{ maxLength: 2000 }}
            />
        </div>
    );
};

MedicalRecord.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func,
    onAddTag: PropTypes.func,
};

export default MedicalRecord;
